<template>
    <div>
        <card-table title="Selection" :items="items" :headers="headers" :controls="tableControls">

            <template slot="cell" slot-scope="cellData">

                <a v-if="userPermissions.view == true" :href="viewUrl(cellData.rowData.item.id)" class="btn btn-view border border-dark"> View </a>

                <a v-if="userPermissions.edit == true" :href="editUrl(cellData.rowData.item.id)" class="btn btn-edit border border-dark"> Edit </a>

                <form v-if="userPermissions.edit == true" method="POST" :action="deleteUrl(cellData.rowData.item.id)" class="d-inline">
                    <input type="hidden" name="_method" value="DELETE">
                    <input type="hidden" name="_token" :value="csrf">
                    <button class="btn btn-delete border border-dark" type="submit"> Delete </button>
                </form>

            </template>

        </card-table>
    </div>
</template>

<script>

import PermissionButtons from '../mixins/PermissionButtonsMixin';
 
export default {

    mixins: [PermissionButtons],

    props: {
        headers: {
            type: Array,
            requred: true,
        },

        items: {
            type: Array,
            requred: true,
        },

        url: {
            type: String,
            required: true,
        }
    },

    data() {

        return {

            tableControls: {
                search: true,
                sort: true,
                itemsPerPage: 15,
            },

            csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
        };
    },

    methods: {

        viewUrl(id) {
            return this.url + '/' + id;
        },

        editUrl(id) {
            return this.url + '/' + id + '/edit';
        },

        deleteUrl(id) {
            return this.url + '/' + id;
        },

    },

}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/common/CrudTable.vue